/**
 * @Description 选址地图青春版本
 */

import { get, post } from '../request';

/**
 * 竞品品牌开店趋势
 * https://yapi.lanhanba.com/project/349/interface/api/86162
 */
export function brandMonthTendency(params: any) {
  return get('/youth/map/queryMonthTendency', { ...params });
}

/**
 * 本品牌开店趋势
 * https://yapi.lanhanba.com/project/349/interface/api/86666
 */
export function queryOpeningTendency(params: any) {
  return get('/youth/map/queryOpeningTendency', { ...params });
}
/**
 * 商圈-概览基础信息
 * https://yapi.lanhanba.com/project/546/interface/api/88398
 */
export function getOverviewBase(params: any) {
  return post('/youth/map/modelCluster/overview/base', params);
}

/**
 * 商圈-评分数据
 * https://yapi.lanhanba.com/project/546/interface/api/88398
 */
export function getClusterScores(params: any) {
  return post('/youth/map/modelCluster/scores', params);
}


/**
 * 商圈-商圈内包含信息
 * https://yapi.lanhanba.com/project/546/interface/api/88404
 */
export function getClusterBrands(params: any) {
  return post('/youth/map/modelCluster/containInfo', params);
}


/**
 * 查询打卡任务
 * https://yapi.lanhanba.com/project/546/interface/api/88220
 */
export function postCheckInQueryTaskModelList(params: any) {
  return post('/standard/checkIn/queryTaskModelList', { ...params });
}

/**
 * 创建打卡任务
 * https://yapi.lanhanba.com/project/546/interface/api/88218
 */
export function postCheckInCreateTask(params: any) {
  return post('/standard/checkIn/createTask', { ...params });
}
